import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

interface Breadcrumb {
  label: string;
  url: string;
}

interface NavigationPage { title: string; link: string; }

@Component({
  selector: 'app-assurance-dommages-ouvrage-maitre',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-dommages-ouvrage-maitre.component.html',
  styleUrls: ['./assurance-dommages-ouvrage-maitre.component.scss']
})
export class AssuranceDommagesOuvrageMaitreComponent {
  title = 'Assurance Dommages-Ouvrage Maître d\'Ouvrage';
  subtitle = 'Protection pour les maîtres d\'ouvrage professionnels';
  phoneNumber = '01 42 27 12 43';
  heroImage = 'assets/images/hero-do-maitre.jpg';

  breadcrumbs: Breadcrumb[] = [
    { label: 'Entreprises', url: '' },
    { label: 'Assurance Dommages-Ouvrage Maître', url: '' }
  ];

  prevPage: NavigationPage = { title: 'Assurance Décennale Construction', link: '/entreprises/assurance-decennale-construction'
  };

  nextPage: NavigationPage = { title: 'Assurance Tous Risques Chantier', link: '/entreprises/assurance-tous-risques-chantier'
  };
}
